import { Address } from '@shared/api';
import { DetailedService } from '@shared/types/service';

export interface ServiceOrderRequest {
  contactInformation:
    | ServicesPersonContactInformation
    | ServicesFinlandPersonContactInformation
    | ServicesCorporateContactInformation
    | ServicesBankIdPersonContactInformation
    | ServicesBankIdCorporateContactInformation;
  accessId: string;
  serviceProviderProductId: string;
  connectionDate: string;
  verificationId?: string;
  customerIdentification: CustomerIdentification;
  campaignCode?: string;
}

export interface ServiceOrderResponse {
  accessId: string;
  id: string;
  contactInformation: ServicesPersonContactInformation;
  shippingAddress: Address;
  serviceProviderProductSummary: DetailedService;
  orderDate: string;
  ispContactInformation: IspContactInformation;
  connectionDate: string;
}

export interface ServicesPersonContactInformation {
  customerType: CustomerType.Person;
  firstName: string;
  lastName: string;
  personalIdentityNumber: string;
  phoneNumberMobile: string;
  email: string;
}

export interface ServicesFinlandPersonContactInformation {
  customerType: CustomerType.PersonFinland;
  firstName: string;
  lastName: string;
  personalIdentityNumber: string;
  phoneNumberMobile: string;
  email: string;
}

export interface ServicesBankIdPersonContactInformation {
  customerType: CustomerType.BankIdPerson;
  phoneNumberMobile: string;
  email: string;
}

export interface ServicesCorporateContactInformation {
  customerType: CustomerType.Corporate;
  corporateName: string;
  orgNumber: string;
  contactPersonFirstName: string;
  contactPersonLastName: string;
  phoneNumberMobile: string;
  email: string;
}

export interface ServicesBankIdCorporateContactInformation {
  customerType: CustomerType.BankIdCorporate;
  corporateName: string;
  orgNumber: string;
  contactPersonFirstName: string;
  contactPersonLastName: string;
  phoneNumberMobile: string;
  email: string;
}

export interface IspContactInformation {
  email?: string;
  phoneNumber?: string;
  url?: string;
}

export enum CustomerIdentification {
  AlreadyIdentified = 'ALREADY_IDENTIFIED',
  BankId = 'BANK_ID',
  Other = 'OTHER',
}

export enum CustomerType {
  Person = 'PERSON',
  PersonFinland = 'PERSON_FINLAND',
  Corporate = 'CORPORATE',
  BankIdPerson = 'BANK_ID_PERSON',
  BankIdCorporate = 'BANK_ID_CORPORATE',
}
